import { FEATURE_REQUEST_PLATFORM_URL } from '@repo/utils/url';

export const options = [
  [
    {
      label: 'Blog',
      link: '/blog',
    },
    {
      label: 'Legal Details',
      link: '/legal',
    },
    {
      label: 'Terms of Use',
      link: '/terms',
    },
    {
      label: 'Privacy Policy',
      link: '/privacy',
    },
  ],
  [
    {
      label: 'Licensing',
      link: '/licensing',
    },
    {
      label: 'Help',
      link: '/help',
    },
    {
      label: 'Contact',
      link: '/contact',
    },
    {
      label: 'Feature Request',
      link: FEATURE_REQUEST_PLATFORM_URL,
      newTab: true,
    },
    {
      label: 'Affiliates',
      link: '/affiliates',
    },
  ],
];
